module.exports = __webpack_public_path__ + "img/aeroland-payment-hero-bg.966f2fb1.jpg";